// temporary feature switches:
export var USE_FRODOR_FOOTER = false;
export var USE_SEARCH = false;